import {
  Sparkles, Lightbulb, Truck, UtensilsCrossed, Flame, Languages, Camera, Film, Clapperboard, Projector,
  PenTool, Radio, Target, Users, Megaphone, Gift, Coins, Star, Mic2, FileText, Plane, ShieldCheck, Gem, Newspaper,
} from "lucide-react";

const MAP = {
  sparkles: Sparkles, lightbulb: Lightbulb, truck: Truck, utensils: UtensilsCrossed, flame: Flame,
  languages: Languages, camera: Camera, film: Film, clapperboard: Clapperboard, projector: Projector,
  pen: PenTool, radio: Radio, target: Target, users: Users, megaphone: Megaphone, gift: Gift, coins: Coins,
  star: Star, mic: Mic2, file: FileText, plane: Plane, shield: ShieldCheck, newspaper: Newspaper,
};

export const ICON_NAMES = Object.keys(MAP);

export const Icon = ({ name, className = "" }) => {
  const C = MAP[name] || Gem;
  return <C className={className} strokeWidth={1.3} />;
};
